import { ChevronRightIcon } from '@langchain/untitled-ui-icons';
import { Link } from '@mui/joy';

import { ReactNode } from 'react';

export interface ManifestNavigationValue {
  name?: ReactNode;
  parent: ReactNode;
  onBack: () => void;
}

export function ManifestNavigation(props: {
  navigation: ManifestNavigationValue | undefined;
}) {
  if (props.navigation == null) return null;
  return (
    <div className="flex items-center gap-2">
      {props.navigation.parent && (
        <Link onClick={props.navigation.onBack} sx={{ lineHeight: '1em' }}>
          {props.navigation.parent}
        </Link>
      )}
      <ChevronRightIcon className="size-4" />
      {props.navigation.name && <span>{props.navigation.name}</span>}
    </div>
  );
}
